import {
    Button,
    Card,
    CardMedia,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Stack,
    styled,
    TextField,
    Typography,
    Box,
    useTheme
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import moment from "moment";
import React, {
    useEffect,
    useState
} from "react";
import { connect } from "react-redux";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import { Required } from "ui-component/custom-components/mandatory";
import { useDropzone } from 'react-dropzone';
import { appVersionEdit, appVersionEditErrorClear } from "store/app/app-management/app-version/actions";
import UploadCover from 'assets/images/upload/upload.svg';
import Chip from "ui-component/extended/Chip";
import SubCard from "ui-component/cards/SubCard";

const DropzoneWrapper = styled('div')(({ theme }) => ({
    outline: 'none',
    overflow: 'hidden',
    position: 'relative',
    padding: theme.spacing(2, 2),
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create('padding'),
    backgroundColor: theme.palette.background.paper,
    border: `1px dashed ${theme.palette.primary.main}`,
    '&:hover': { opacity: 0.72, cursor: 'pointer' }
}));

const EditAppVersion = (props) => {

    const { open, filter, paginationData, errorMessage, onClose, isPending, appVersionDetails } = props;
    const theme = useTheme();
    const [appVersionData, setAppVersionData] = useState();
    const [file, setFile] = useState();
    const [errors, setErrors] = useState({});
    const [showDropzone, setShowDropzone] = useState(false);
    useEffect(() => {
        props.appVersionEditErrorClear();
        setAppVersionData(appVersionDetails);
        setErrors({});
        setShowDropzone(false);
        setFile();
    }, [open])

    const validateOnchange = (e) => {
        const { name, value } = e.target;
        setAppVersionData({
            ...appVersionData,
            [name]: value
        })
        setErrors({
            ...errors,
            [name]: null,
        })
    }

    const validateOnDate = (name, date) => {
        const formattedDate = date ? moment(date).format("YYYY-MM-DD") : null;
        setAppVersionData({
            ...appVersionData,
            [name]: formattedDate
        })
        setErrors({
            ...errors,
            [name]: null,
        })
    }

    const handleChangePassword = (e) => {
        e.preventDefault();

        const { versionNo, releasedDate } = appVersionData || {};
        const currentErrors = {};

        if (!versionNo && !versionNo?.trim()) {
            currentErrors.versionNo = 'Version no is required';
        }
        if (!releasedDate && !releasedDate?.trim()) {
            currentErrors.releasedDate = 'Released date is required';
        }
        setErrors(currentErrors);

        if (Object.keys(currentErrors).length === 0) {
            props.appVersionEdit({ ...appVersionData, appAPK: file }, filter, paginationData);
        }
    }

    //----------------UPLOAD APK---------------------------------------------------
    const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
        accept: {
            '.apk,application/vnd.android.package-archive': []
        },
        multiple: false,
        onDrop: (acceptedFiles) => {
            setFile(
                //   'files',
                acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file)
                    })
                )
            );
        }
    });

    const thumbs =
        file &&
        file.map((item, index) => (
            <Box
                key={index}
                sx={{ bgcolor: 'background.paper', top: 8, left: 0, borderRadius: 2, position: 'absolute', width: 1, height: 1 }}
            >
                <img
                    alt={item.name}
                    src={item.preview}
                    style={{ width: 'calc(100% - 16px)', height: 'calc(100% - 16px' }}
                    onLoad={() => {
                        URL.revokeObjectURL(item.preview);
                    }}
                />
            </Box>
        ));

    const onRemove = () => {
        setFile(null);
    };

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    console.log("files: ", file)
    return (
        <>
            <Dialog open={open} maxWidth={'xs'} fullWidth onClose={validateClose}>
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Edit App Version
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                {errorMessage && <ErrorAlert content={errorMessage} />}
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={3} justifyContent={'center'} direction={'column'}>
                                            <Grid item >
                                                <TextField
                                                    label={<div >Version No<Required /></div>}
                                                    autoFocus
                                                    fullWidth
                                                    size="small"
                                                    name='versionNo'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={appVersionData?.versionNo}
                                                    error={errors?.versionNo}
                                                    helperText={errors?.versionNo}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DatePicker
                                                        label={<div >Released Date<Required /></div>}
                                                        onChange={(date) => validateOnDate("releasedDate", date)}
                                                        fullWidth
                                                        format="DD/MM/YYYY"
                                                        value={appVersionData?.releasedDate ? moment.utc(appVersionData.releasedDate, "YYYY-MM-DD") : null}
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                                error: errors?.releasedDate,
                                                                helperText: errors?.releasedDate
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item >
                                                <TextField
                                                    label={<>Notes </>}
                                                    fullWidth
                                                    multiline
                                                    rows={2}
                                                    size="small"
                                                    name='notes'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={appVersionData?.notes || ""}
                                                />
                                            </Grid>
                                            <SubCard title="Select APK File" sx={{ whiteSpace: "wrap" }}>
                                                {(!showDropzone && appVersionData?.appName) ?
                                                    <Stack alignItems="center" spacing={2} direction="row" sx={{ padding: "20px" }}>
                                                        <Typography
                                                            color={theme.palette.primary.dark}
                                                            variant="h5" component={Chip}
                                                            label={appVersionData?.appName}
                                                        />
                                                        <IconButton onClick={() => setShowDropzone(true)}
                                                            variant="contained"
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: theme.palette.error.dark,
                                                                color: "white",
                                                                borderRadius: "10px",
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.error.dark,
                                                                    color: "white",
                                                                }
                                                            }}
                                                        >
                                                            <IconX />
                                                        </IconButton>
                                                    </Stack>
                                                    :
                                                    <Grid item sx={{ padding: "20px" }}>
                                                        <DropzoneWrapper
                                                            {...getRootProps()}
                                                            sx={{
                                                                ...(isDragActive && { opacity: 0.72 }),
                                                                ...((isDragReject || errorMessage) && { color: 'error.main', borderColor: 'error.light', bgcolor: 'error.lighter' }),
                                                                ...(file && { padding: '12% 0' })
                                                            }}
                                                        >
                                                            <input {...getInputProps()} />
                                                            <Stack
                                                                spacing={1}
                                                                alignItems="center"
                                                                justifyContent="center"
                                                                direction={{ xs: 'column', md: 'row' }}
                                                                sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
                                                            >
                                                                <CardMedia component="img" image={UploadCover} sx={{ width: 100 }} />
                                                                <Stack sx={{ p: 0 }} spacing={1}>
                                                                    <Typography variant="h5">Drag & Drop or Select APK</Typography>
                                                                    <Typography color="secondary.main">
                                                                        Drop APK files here or click&nbsp;
                                                                        <Typography component="span" color="primary" sx={{ textDecoration: 'underline' }}>
                                                                            browse
                                                                        </Typography>
                                                                        &nbsp;through your machine
                                                                    </Typography>
                                                                </Stack>
                                                            </Stack>
                                                            {thumbs}
                                                        </DropzoneWrapper>
                                                        {file && file.length > 0 ? (
                                                            <Grid container direction="row" justifyContent="flex-end" sx={{ mt: 1.5 }}>
                                                                <Button variant="contained" color="error" onClick={onRemove} size="small">
                                                                    Remove
                                                                </Button>
                                                            </Grid>
                                                        ) :
                                                            appVersionData?.appName &&
                                                            <Grid container direction="row" justifyContent="flex-end" sx={{ mt: 1.5 }}>
                                                                <Button variant="contained" color="error" onClick={() => setShowDropzone(false)} size="small">
                                                                    Cancel
                                                                </Button>
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                }
                                            </SubCard>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleChangePassword}
                                                size="small"
                                                color="primary"
                                                disabled={isPending || Object.keys(removeEmptyKeys(errors))?.length > 0}
                                            >
                                                {isPending ? <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <CircularProgress size={'20px'} color='inherit' />
                                                    Loading...
                                                </div>
                                                    : 'Submit'
                                                }
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={onClose}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                            >
                                                Close
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }
            </Dialog >
        </>
    )
}

const mapStateToProps = (state) => ({
    appVersionDetails: state.appVersions.appVersionDetails,
    isPending: state.appVersions.isAppVersionEditPending,
    errorMessage: state.appVersions.appVersionEditErrorMessage,
})
const mapDispatchToProps = (dispatch) => ({
    appVersionEdit: (formData, filter, paginationData) => dispatch(appVersionEdit(formData, filter, paginationData)),
    appVersionEditErrorClear: () => dispatch(appVersionEditErrorClear()),
})

export default connect(mapStateToProps, mapDispatchToProps)(EditAppVersion);